import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { reasons } from '../../constants-monisfer-infos';

@Component({
  selector: 'app-reasons-why-us',
  imports: [MatProgressSpinnerModule, NgOptimizedImage],
  templateUrl: './reasons-why-us.component.html',
  styleUrl: './reasons-why-us.component.scss',
})
export class ReasonsWhyUsComponent {
  readonly reasons = reasons;
}
